function escapeCsvValue(value) {
  if (value === null || value === undefined) return '';
  const stringValue = String(value);
  if (stringValue === '') return '';
  const needsQuoting = /["\n\r,]/.test(stringValue);
  if (!needsQuoting) return stringValue;
  const escaped = stringValue.replace(/"/g, '""');
  return `"${escaped}"`;
}

export function downloadCsv({ filename, columns, rows }) {
  if (!Array.isArray(columns) || !columns.length || !Array.isArray(rows) || !rows.length) {
    return;
  }

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const header = columns
    .map((column) => escapeCsvValue(column.label || column.key || ''))
    .join(',');

  const dataLines = rows.map((row) => {
    return columns
      .map((column) => {
        const raw = typeof column.value === 'function'
          ? column.value(row)
          : (column.key ? row[column.key] : '');
        return escapeCsvValue(raw);
      })
      .join(',');
  });

  const csvContent = [header, ...dataLines].join('\r\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename || 'export.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export default downloadCsv;
